"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripTemplateDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function tripTemplateDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        name: (0, deserializeString_1.deserializeString)(object.name),
        vendorId: (0, unwrap_1.default)(object.vendorId, deserializeString_1.deserializeString),
        locations: object.locations,
    };
}
exports.tripTemplateDeserialize = tripTemplateDeserialize;
